import { connect } from 'react-redux';

import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { Feedback, IFeedbackProps } from './Feedback';
import { setDimensionsFeedback } from '../../actions/feedback';
import { defaultState } from '../../reducers/feedback';

type TStoreProps = Pick<IFeedbackProps, 'screen' | 'isVisibleForm'>;
type TDispatchProps = Pick<IFeedbackProps, 'setDimensionsFeedback'>;

export function mapStateToProps(state: IApplicationState): TStoreProps {
  const isVisibleForm =
    typeof state.feedback.isVisibleForm === 'boolean'
      ? state.feedback.isVisibleForm
      : (defaultState.isVisibleForm as boolean);

  return {
    screen: state.feedback.screen,
    isVisibleForm,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TDispatchProps {
  return {
    setDimensionsFeedback: (top: number, height: number) => dispatch(setDimensionsFeedback(top, height)),
  };
}

export const FeedbackContainer = connect(mapStateToProps, mapDispatchToProps)(Feedback);
